import styled, { css } from 'styled-components';

import { floorGameColor as color, styledLayout, styledTypography } from '@pkg/primitives';

import { tokens } from '../../../../tokens';

interface StyledTierStatsProps {
    $compact?: boolean;
}

// Do we actually want truncation?
const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.truncate};
    ${styledTypography.truncateHeightFix(true)};
`;

export const StyledTierStats = styled.div<StyledTierStatsProps>`
    ${styledLayout.fullWidthFix};

    --yat_activity-tier-stats-primary-font-size: ${({ $compact }) =>
        tokens.priceGame.tierStats.primary.fontSize[$compact ? 'compact' : 'default']}px;
    --yat_activity-tier-stats-secondary-font-size: ${({ $compact }) =>
        tokens.priceGame.tierStats.secondary.fontSize[$compact ? 'compact' : 'default']}px;

    text-align: right;
`;

export const Primary = styled.p`
    ${typographyBase};
    font-size: var(--yat_activity-tier-stats-primary-font-size);
    font-weight: 700;
    color: ${color.white};
`;

export const Count = styled.span`
    --yat_activity-tier-stats-gradient: linear-gradient(90deg, #24ec8c 0%, #5dba24, #edff18 100%);

    ${styledTypography.gradient('var(--yat_activity-tier-stats-gradient)')};
`;

export const Secondary = styled.p`
    ${typographyBase};
    margin-top: 0.2em;
    font-size: var(--yat_activity-tier-stats-secondary-font-size);
    font-weight: 700;
    color: rgba(255, 255, 255, 0.5);
`;
